import React from "react";
import SectionHead from "../ui/SectionHead";
import SelectCard from "../ui/SelectCard";

export default function OptionsStep({ step, value, onSelect }) {
  return (
    <div>
      <SectionHead title={step.subtitle} subtitle="Wählen Sie eine Option aus." />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {step.options.map((opt) => {
          const Icon = opt.icon; // may be undefined

          return (
            <SelectCard
              key={opt.key}
              title={opt.label}
              subtitle={opt.subtitle || "Auswählen"}
              icon={Icon ? <Icon /> : <FallbackIcon />}   // ✅ SAFE
              selected={value === opt.key}
              onClick={() => onSelect(opt.key)}
            />
          );
        })}
      </div>
    </div>
  );
}

function FallbackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 6h16v12H4V6Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M8 10h8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8 14h6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
